import { useCallback, useEffect, useState } from 'react';

import adminApi from '../../../services/adminApi';
import { social } from '../../../services/api/admin';

const EMPTY_DATA = {
  unreadInbox: null,
  subscribers: null,
  newsletters: null,
  scheduledPosts: null,
  approvedPosts: null,
  events: null,
  feedback: null,
};

const REQUESTS = {
  unreadInbox: async () => {
    const response = await adminApi.get('/api/admin/inbox/unread-count');
    return adminApi.getJson(response);
  },
  subscribers: async () => {
    const response = await adminApi.get('/api/admin/newsletter/recipients/count');
    return adminApi.getJson(response);
  },
  newsletters: async () => {
    const response = await adminApi.get('/api/admin/newsletter/newsletters?status=sent');
    return adminApi.getJson(response);
  },
  scheduledPosts: () => social.listPosts({ status: 'scheduled', page: 1, page_size: 1 }),
  approvedPosts: () => social.listPosts({ status: 'approved', page: 1, page_size: 1 }),
  events: async () => {
    const response = await adminApi.get('/api/admin/events?include_past=false');
    return adminApi.getJson(response);
  },
  feedback: async () => {
    const response = await adminApi.get('/api/admin/feedback/stats?days=30');
    return adminApi.getJson(response);
  },
};

/**
 * Load the cockpit snapshot without coupling failures between domains. A broken
 * optional service should not hide healthy outreach metrics.
 */
export const loadOutreachCockpitData = async () => {
  const entries = Object.entries(REQUESTS);
  const results = await Promise.allSettled(entries.map(([, request]) => request()));

  return results.reduce(
    (snapshot, result, index) => {
      const [key] = entries[index];
      if (result.status === 'fulfilled') {
        snapshot.data[key] = result.value;
      } else {
        snapshot.errors.push(key);
      }
      return snapshot;
    },
    { data: { ...EMPTY_DATA }, errors: [] }
  );
};

export const useOutreachCockpitData = () => {
  const [snapshot, setSnapshot] = useState({ data: EMPTY_DATA, errors: [] });
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    setLoading(true);
    const nextSnapshot = await loadOutreachCockpitData();
    setSnapshot(nextSnapshot);
    setLoading(false);
    return nextSnapshot;
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { ...snapshot, loading, refresh };
};

